import * as React from "react";

/**
 * Popover menu (DS: a white card with a lavender hairline, 12px corners and the lg shadow; rows gain
 * the lavender wash on hover). Compose with MenuItem. `tone="hud"` is the ink surface for the
 * desktop tray and recorder HUD only.
 */
export interface MenuProps {
  header?: React.ReactNode;
  /** "light" (default) for every in-app popover; "hud" for the always-ink tray / HUD menu. */
  tone?: "light" | "hud";
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export function Menu({ header, tone = "light", children, className, style }: MenuProps): JSX.Element {
  return (
    <div role="menu" className={["gk-menu", tone === "hud" && "gk-menu--hud", className].filter(Boolean).join(" ")} style={style}>
      {header && (
        <>
          <div className="gk-menu__head">{header}</div>
          <div className="gk-menu__sep" />
        </>
      )}
      {children}
    </div>
  );
}
